import { createFileRoute } from "@tanstack/react-router";
import { BrandAssetsComponent } from "@/pages/brand-assets";
import { head, loader } from "@/pages/brand-assets.meta";

export const Route = createFileRoute("/$locale/brand-assets")({
  loader,
  head,
  component: BrandAssetsComponent,
});
